<template>
  <div class="relative rounded select-none" v-click-outside="closeDropdown">
    <!-- Icon and trigger -->
    <div class="p-3 relative cursor-pointer" :class="{ 'sm:p-1': small }">
      <div class="relative flex items-center gap-2">
        <div
          v-if="!small"
          class="
            text-white
            p-2
            gap-x-1
            rounded-full
            h-6
            w-20
            -right-4
            top-0
            flex
            items-center
            justify-center
          "
          :class="{
            'bg-gray-500': isMuted,
            'bg-red-500': !isMuted,
          }"
        >
          <div v-if="!isMuted" class="bg-white w-2 h-2 rounded-full"></div>
          <span class="">
            {{ isMuted ? 'Paused' : 'Live' }}
          </span>
        </div>
        <div
          data-cy="toggle-focus"
          :class="{ 'sm:p-1': small }"
          class="
            bg-vice-dark-grey bg-opacity-70
            text-white
            rounded-full
            flex
            justify-center
            items-center
            p-2
            hover:bg-opacity-90
          "
          @click="toggleFocus()"
        >
          <ArrowsExpandIcon class="h-6 w-6" v-if="!isFocused" :class="{ 'sm:w-4 sm:h-4': small }" />
          <ArrowsCollapseIcon class="p-0.5" v-else />
        </div>
      </div>
    </div>
    <!-- Actions -->
    <div
      v-if="dropdownOpen"
      class="
        top-full
        absolute
        rounded
        bg-white
        opacity-
        text-left text-vice-teal-600
        right-2
        p-3
        flex flex-col
        text-sm
      "
    >
      <h3 class="font-bold mb-2">Stream settings</h3>
      <div class="flex items-center gap-10">
        <div class="flex items-center">
          <EyeIcon class="w-5 h-5 mr-2" />
          Focus
        </div>
        <ToggleIcon :isEnabled="isFocused" @stateToggled="toggleFocus()"></ToggleIcon>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3';

import { ref } from 'vue';
import { ArrowsExpandIcon } from '@heroicons/vue/outline';
import { EyeIcon } from '@heroicons/vue/solid';
import ArrowsCollapseIcon from '@/Components/Icons/ArrowsCollapseIcon.vue';
import ToggleIcon from '@/Components/Inputs/ToggleIcon.vue';

export default {
  name: 'GridItemActionsPanel',
  props: {
    streamId: {
      type: String,
    },
    isFocused: {
      type: Boolean,
    },
    small: {
      type: Boolean,
      default: false,
    },
    isMuted: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['focusToggled'],
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    ArrowsExpandIcon,
    ArrowsCollapseIcon,
    EyeIcon,
    ToggleIcon,
  },

  setup(props, { emit }) {
    const dropdownOpen = ref(false);
    // Dropdown state
    const toggleDropdown = () => {
      dropdownOpen.value = !dropdownOpen.value;
    };

    const closeDropdown = () => {
      dropdownOpen.value = false;
    };

    // Toggles states
    const videoState = ref(false);
    const audioState = ref(false);

    const toggleVideo = () => {
      videoState.value = !videoState.value;
    };
    const toggleAudio = () => {
      audioState.value = !audioState.value;
    };
    const toggleFocus = () => {
      emit('focusToggled', props.isFocused ? null : props.streamId);
      closeDropdown();
    };

    return {
      dropdownOpen,
      toggleDropdown,
      closeDropdown,
      toggleVideo,
      toggleAudio,
      toggleFocus,
      videoState,
      audioState,
    };
  },
};
</script>
